import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useState} from 'react'
import UseState from "../../UseState";
import Modal from "../../Modal/Modal";
import {LayoutContext} from "../../layouts/Default/LayoutContext";
import {NullAsDefault, renderIf, renderIfElse} from "../../../views/Shared";
import {BiTrash} from "react-icons/bi";
import preventParentEvent from "../../../helpers/preventParentEvent";
import {Button} from "antd";
import {BsGeoAltFill} from "react-icons/bs";
import {useToggle} from "react-use";
import {LeafletMap} from "./LeafletMap";
import CustomButton from "../../../views/AppLocals/custom/CustomButton";
import {DelayRender} from "../../../views/Shared/components/DelayRender";
import GMapWidget, {getStaticMap} from "../../../views/Chart/GMap/GMapWidget";

export const ToggleMap = ({preview_url, latitude, longitude, onClick = NullAsDefault, onRemove = NullAsDefault}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)


    const renderMap = useCallback(() => {
        if (latitude && longitude) {
            return (
                <LeafletMap {...{latitude, longitude}} />
            )
        } else if (preview_url) {
            return (
                <img
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        objectFit: 'cover',
                    }}
                    className="w-full h-full"
                    src={preview_url}
                    alt={preview_url || ''}
                />
            )
        } else {
            return (
                <div
                    className="h-full flex flex-center flex-col gap-2 border border-color-50 hover:border-secondary hover:shadow-md rounded-lg cursor-pointer">
                    <BsGeoAltFill size={50} className="text-color-500"/>
                    <CustomButton ift="add-map" label="add map" type="primary" textSize="text-xs"/>
                </div>
            )
        }
    }, [preview_url])

    return (
        <div
            onClick={onClick}
            style={{height: isSm ? 140 : 180}}
            className="w-full relative z-10">
            {renderMap()}
            {renderIf(
                !!preview_url && onRemove !== NullAsDefault,
                <BiTrash
                    style={{
                        position: 'absolute',
                        right: 10,
                        top: 10,
                        padding: 5,
                        zIndex: 400,
                    }}
                    size={25}
                    className="background text-red-300 hover:text-red-600 border border-red-300 rounded shadow cursor-pointer"
                    onClick={(e) => {
                        preventParentEvent(e)
                        onRemove()
                    }}
                />
            )}
        </div>
    )
}

export const LocationStaticMap = ({
                                      latLng,
                                      toggle,
                                      isToggle,
                                      locationName,
                                      onSelect = NullAsDefault,
                                  }) => {
    const t = useTranslate()

    const [currentZoom, setCurrentZoom] = useState()

    const [defaultLat, defaultLng] = latLng || [,]

    return (
        <UseState>
            {([location, setLocation]) => (
                <Modal
                    className="custom-modal"
                    width={800}
                    footer={null}
                    closable={false}
                    open={isToggle}
                    destroyOnHidden={true}>
                    <DelayRender lazy={true}>
                        <GMapWidget
                            height={600}
                            onZoomChanged={(zoom) => {
                                setCurrentZoom(zoom)
                            }}
                            onLocationFound={() => {
                                setLocation(undefined)
                            }}
                            data={
                                _.some(latLng, (e) => !e)
                                    ? undefined
                                    : [
                                        {
                                            name: locationName,
                                            latitude: defaultLat,
                                            longitude: defaultLng,
                                            anonymous: _.isEmpty(locationName),
                                        },
                                    ]
                            }
                            renderMarker={(item) => {
                                const {latitude, longitude} = item
                                return (
                                    <div>
                                        <div>
                                            {`${t('latitude')}: `}
                                            <span className="font-semibold">{latitude}</span>
                                        </div>
                                        <div>
                                            {`${t('longitude')}: `}
                                            <span className="font-semibold">{longitude}</span>
                                        </div>
                                    </div>
                                )
                            }}
                            onSelectLocation={(data) => {
                                setLocation(data)
                            }}
                            settings={{
                                dragging: true,
                                zoomControl: true,
                                doubleClickZoom: false,
                                scrollWheelZoom: false,
                            }}
                        />
                    </DelayRender>
                    <div className="mt-4 flex justify-end gap-2">
                        <div
                            className="px-4 flex flex-center text-color-300 hover:text-color-100 cursor-pointer"
                            onClick={() => {
                                toggle(false)
                            }}>
                            {t('cancel')}
                        </div>
                        <Button
                            color="primary" variant="solid"
                            className="no-border"
                            disabled={!location}
                            onClick={() => {
                                const [latitude, longitude] = location?.latLng || [,]
                                const {imageURL} = getStaticMap({
                                    latitude,
                                    longitude,
                                    zoom: currentZoom,
                                })
                                onSelect({
                                    latitude,
                                    longitude,
                                    map_preview: imageURL,
                                })
                                toggle(false)
                            }}>
                            {t('select')}
                        </Button>
                    </div>
                </Modal>
            )}
        </UseState>
    )
}


export const LocationStaticViewMap = ({
                                          latLng,
                                          placement,
                                          locationName,
                                      }) => {
    const t = useTranslate()
    const [isToggle, toggle] = useToggle(false);

    const [defaultLat, defaultLng] = latLng || [,]

    return renderIfElse(!isToggle,
        <div onClick={() => {
            toggle()
        }}>
            {placement}
        </div>,
        <Modal
            className="custom-modal"
            width={800}
            footer={null}
            closable={true}
            onCancel={toggle}
            open={isToggle}
            destroyOnHidden={true}>
            <DelayRender lazy={true}>
                <GMapWidget
                    height={600}
                    data={
                        _.some(latLng, (e) => !e)
                            ? undefined
                            : [
                                {
                                    name: locationName,
                                    latitude: defaultLat,
                                    longitude: defaultLng,
                                    anonymous: _.isEmpty(locationName),
                                },
                            ]
                    }
                    renderMarker={(item) => {
                        const {latitude, longitude} = item
                        return (
                            <div>
                                <div>
                                    {`${t('latitude')}: `}
                                    <span className="font-semibold">{latitude}</span>
                                </div>
                                <div>
                                    {`${t('longitude')}: `}
                                    <span className="font-semibold">{longitude}</span>
                                </div>
                            </div>
                        )
                    }}
                    settings={{
                        dragging: true,
                        zoomControl: true,
                        doubleClickZoom: false,
                        scrollWheelZoom: false,
                    }}
                />
            </DelayRender>
        </Modal>
    )
}